/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const MapPinAtm = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.1328 22.7239L11.1368 22.7267H12H12.8632L12.8672 22.7239L12.874 22.7191L12.8955 22.7038C12.9133 22.691 12.9381 22.6731 12.9694 22.6502C13.0319 22.6045 13.1205 22.5389 13.2314 22.4543C13.4531 22.2854 13.7647 22.0406 14.1365 21.7284C14.8778 21.1059 15.8693 20.2063 16.8653 19.0989C18.8041 16.9432 21 13.7362 21 10.1C21 6.49582 18.9218 3.36523 15.8964 1.89394L15.1278 3.1904C17.7082 4.39181 19.5 7.03386 19.5 10.1C19.5 16.2222 12 21.5 12 21.5C12 21.5 4.5 16.2222 4.5 10.1C4.5 6.15914 7.46001 2.91884 11.25 2.53753V5.58478C9.77764 5.82272 8.79247 6.75046 8.79247 8.03184C8.79247 9.63084 9.84547 10.2678 11.1065 10.6188L12.7185 11.0868C13.4335 11.2948 13.9535 11.6978 13.9535 12.4258C13.9535 13.2318 13.2125 13.7648 12.0815 13.7648C10.9245 13.7648 10.0015 12.9588 9.92347 11.9058H8.42847C8.54389 13.5859 9.6841 14.7345 11.25 15.0273V17H12.75V15.0645C14.4343 14.8604 15.5005 13.8468 15.5005 12.3868C15.5005 10.6578 14.4345 10.0208 13.1345 9.65684L11.4965 9.18884C10.8075 8.99384 10.3395 8.66884 10.3395 8.01884C10.3395 7.29084 10.9635 6.84884 12.0035 6.84884C13.0825 6.84884 13.7585 7.44684 13.8885 8.22684H15.3835C15.2695 6.78366 14.2557 5.82126 12.75 5.57976L12.75 2.53753L12.75 2L12.75 1.03107C12.5028 1.01049 12.2526 1 12 1C7.01077 1 3 5.093 3 10.1C3 13.7362 5.1959 16.9432 7.13473 19.0989C8.13073 20.2063 9.12221 21.1059 9.8635 21.7284C10.2352 22.0406 10.5469 22.2854 10.7686 22.4543C10.8795 22.5389 10.9681 22.6045 11.0306 22.6502C11.0619 22.6731 11.0867 22.691 11.1045 22.7038L11.126 22.7191L11.1328 22.7239Z"
                        fill={color}
                    />
                </svg>
        );
    };
